import './Navbar.css';

function bookingRequest() {
  alert("This feature is coming soon...until then, please call us at (815) 943-6153 during business hours to reserve a table.");
  closeNav();
}

function openNav() {
  document.getElementById("mySidenav").style.height = "100%";
  document.getElementById("iPhone-hamburger").style.display = "none";
  document.getElementById("closebtn").style.display = "block";
  document.getElementById("submit-button").style.display = "none";
  document.body.classList.add('no-scroll');
  document.querySelector('.sidenav').style.display = 'block';
}

function closeNav() {
  document.getElementById("mySidenav").style.height = "0%";
  document.getElementById("iPhone-hamburger").style.display = "block";
  document.getElementById("closebtn").style.display = "none";
  document.getElementById("submit-button").style.display = "block";
  document.body.classList.remove('no-scroll'); // re-enable scroll
  document.getElementById("submit-button").style.textAlign = "center";
  document.getElementById("submit-button").style.margin = "0 auto";

}

function Navbar() {
  return (
    <div className="navbar-div"> 
        <div className="navbar-top-box-shadow"></div>
        <div className="upper-title-div">
        <i onClick={openNav} id="iPhone-hamburger" class="fa-utility fa-semibold fa-bars"></i>
        <text href="javascript:void(0)" id="closebtn" className="closebtn" onClick={closeNav}>&times;</text>
          <h3 className="heritage-house-title">The Heritage House</h3>
          <text className="city-state-in-title">HARVARD, ILLINOIS</text><br/><br/>

          {/* <h3 className="book-table-title">A Supper Club</h3> */}
          {/* <div className="upper-title-bottom-line"></div></div> */}
          <div className="top-top-nav">
            <a className="active" href="/">HOME</a>
            <a href="/our-story">OUR STORY</a>
            <a href="/menu">MENU</a>
            <a onClick={bookingRequest}>BOOK A TABLE</a>
            <a href="/contact-us">CONTACT US</a>
          </div>
</div>
<div id="mySidenav" className="sidenav">
            {/* <div>_________________________________________</div><br/> */}<br/>
            <a onClick={closeNav} href="/">HOME</a>
            <a onClick={closeNav} href="/our-story">ABOUT US</a>
            <a onClick={closeNav} href="/menu">MENU</a>
            <a onClick={bookingRequest}>BOOK A TABLE</a>
            <a onClick={closeNav} href="/contact-us">CONTACT US</a>
          </div>

    </div>
  );
}

export default Navbar;